import { render, staticRenderFns } from "./CellRendererHoursOfRest.vue?vue&type=template&id=6206fb68"
import script from "./CellRendererHoursOfRest.vue?vue&type=script&lang=js"
export * from "./CellRendererHoursOfRest.vue?vue&type=script&lang=js"
import style0 from "./CellRendererHoursOfRest.vue?vue&type=style&index=0&id=6206fb68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports